import { PurchaseFormResponse } from '@Types/api/form';
import { RequestListSearchResponse } from '@Types/api/requestList';

import { parseDateTime } from '@Utils/transformDateTime';
import { TypeDict } from 'types';
import { ColumnDataType } from './type';

export const dataSourceMap = (
  data: RequestListSearchResponse<PurchaseFormResponse>,
  findStatus: (statusNum: number) => TypeDict | undefined,
  findClassification: (classificationId: number) => string
): Array<ColumnDataType> => {
  if (!data?.content) return [];

  return data?.content?.map((purchase) => ({
    key: purchase.reqId,
    prNo: purchase.reqNo,
    bsReqId: purchase.bsReqId,
    reqestFrom: purchase.reqFromId === 1 ? 'Buildsmart' : 'TBMS 2.0',
    tbmsErp: purchase.mrNo,
    materialGroup: purchase.group3Desc,
    classification: findClassification(purchase?.classificationId),
    requestDate: parseDateTime(purchase.reqDate),
    requiredDate: parseDateTime(purchase.requiredOn),
    storeProject: purchase.project,
    purchaseOfficer: purchase.approver,
    status: findStatus(purchase.statusId)?.codeDesc || '',
    action: '',
  }));
};
